<template>
  <div
    class="subscription-row"
    :class="{ 'subscription-row--expandable': hasContentSlot, 'subscription-row--expanded': show }"
  >
    <button type="button" @click="toggle" :tabindex="!hasContentSlot ? '-1' : '0'" class="subscription-row__trigger">
      <div class="subscription-row__wrapper">
        <div class="subscription-row__title">
          <span class="subscription-row__label">{{ row.label }}</span>
          <span class="subscription-row__sublabel" v-if="row.sublabel">{{ row.sublabel }}</span>
          <Badge class="subscription-row__badge" :type="show ? 'filled' : 'outlined'" v-if="row.badge">{{
            row.badge
          }}</Badge>
        </div>
        <span class="subscription-row__price">{{ row.price.toLocaleString('nb-no') }} /mnd</span>

        <slot name="trigger" :open="open"></slot>
      </div>
    </button>
    <slot name="content" v-if="show"></slot>
  </div>
</template>

<script>
import Badge from '@/components/Badge'

export default {
  props: {
    row: Object,
  },

  data() {
    return {
      show: false,
    }
  },

  computed: {
    hasContentSlot() {
      return this.$slots['content']
    },
  },

  methods: {
    toggle() {
      if (!this.hasContentSlot) return
      this.show = !this.show
    },
    open() {
      return this.show
    },
  },

  components: {
    Badge,
  },
}
</script>

<style lang="scss">
.subscription-row {
  padding: 1rem 1.75rem;
  width: 100%;

  // &:first-of-type {
  //   border-top-right-radius: inherit;
  //   border-top-left-radius: inherit;
  // }
  // &:last-of-type {
  //   border-bottom-right-radius: inherit;
  //   border-bottom-left-radius: inherit;
  // }

  &--expandable {
    .subscription-row__trigger {
      &:hover {
        cursor: pointer;
      }
    }
  }

  &:not(:last-of-type) {
    border-bottom: 1px solid var(--border-color);
  }

  &__trigger {
    &:focus {
      border: 1px solid var(--primary);
    }

    &:focus:not(:focus-visible) {
      border: none;
    }
  }

  display: flex;
  flex-direction: column;
  gap: 2rem;

  &--expanded {
    .subscription-row__price {
      font-weight: bold;
    }
    background-color: hsl(var(--border-color-h), var(--border-color-s), calc(var(--border-color-l) + 7%));
    //background-color: #f5f5f5;
  }

  &__wrapper {
    width: 100%;
    display: grid;
    grid-template-columns: auto 1fr 100px;
    align-items: center;
    justify-items: end;
    gap: 1rem;
  }
  &__title {
    display: grid;
    grid-template-columns: auto auto;
    grid-template-areas:
      'label badge'
      'sublabel sublabel';
  }
  &__label {
    grid-area: label;
    font-weight: 700;
  }
  &__sublabel {
    grid-area: sublabel;

    font-size: 0.8rem;
  }
  &__badge {
    margin-left: 1rem;
    grid-area: badge;
  }
  &__price {
  }
}
</style>
